<template>
  <v-form
    ref="form"
    v-model="formValid"
    @submit.prevent="generate()"
  >
    <page-template>
      <template slot="title">
        <page-title
          v-if="pageTitle"
          :title="pageTitle"
          :navigate-back-route="navigateBackRoute"
        />
      </template>
      <template slot="content">
        <v-container
          class="py-0"
          fluid
          grid-list-sm
        >
          <div
            v-for="slot in totalGroup"
            :key="slot"
          >
            <slot
              :name="getSlotGroupName(slot)"
            />
            <v-divider
              v-if="slot !== totalGroup"
              class="my-4"
            />
          </div>

          <v-flex
            class="py-3 text-xs-right"
          >
            <v-divider class="my-4" />
            <btn-primary
              :text="$t('support.components.reports.btnGenerate')"
              :loading="btnLoading"
              type="submit"
            />
          </v-flex>
        </v-container>
      </template>
    </page-template>
  </v-form>
</template>

<script>
import PageTemplate from 'Support/layout/PageTemplate.vue';
import PageTitle from 'Support/layout/PageTitle.vue';
import BtnPrimary from 'Support/components/buttons/BtnPrimary.vue';
import ReportMixin from 'Support/mixins/ReportMixin';
import RouterMixin from 'Support/mixins/router-mixin';
import RulesMixin from 'Support/mixins/rules-mixin';

export default {
  name: 'ReportForm',
  components: {
    PageTemplate,
    PageTitle,
    BtnPrimary,
  },
  mixins: [ReportMixin, RouterMixin, RulesMixin],
  props: {
    loadingReportForm: {
      type: Boolean,
    },
    value: {
      type: Object,
      required: true,
    },
    totalGroup: {
      type: Number,
      required: true,
    },
    pageTitle: {
      type: String,
      default: '',
    },
    navigateBackRoute: {
      type: String,
      required: true,
    },
    requestClass: {
      type: [Function, Object],
      required: true,
    },
    defaultInterval: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    btnLoading() {
      return this.loadingReportForm || this.loadingForm;
    },
    payload: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    navigateToPageAfterGenerate() {
      return this.navigatePageAfterGenerate;
    },
  },
  methods: {
    getSlotGroupName(slot) {
      return `group-${slot}`;
    },
    setEntityData(data) {
      this.payload = data;
    },
    getPayload() {
      return this.payload;
    },
  },
};
</script>
